import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "row crm:mb-6 crm:items-start" }
const _hoisted_3 = { class: "control-label col-sm-6" }
const _hoisted_4 = { class: "col-sm" }
const _hoisted_5 = { class: "crm:flex crm:items-center" }
const _hoisted_6 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_7 = { class: "control-label col-sm-6" }
const _hoisted_8 = { class: "col-sm" }
const _hoisted_9 = {
  key: 0,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_10 = { class: "control-label col-sm-6" }
const _hoisted_11 = { class: "col-sm" }
const _hoisted_12 = {
  key: 1,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_13 = { class: "control-label col-sm-6" }
const _hoisted_14 = { class: "col-sm" }
const _hoisted_15 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_16 = { class: "control-label col-sm-6" }
const _hoisted_17 = { class: "col-sm" }
const _hoisted_18 = {
  key: 2,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_19 = { class: "control-label col-sm-6" }
const _hoisted_20 = { class: "col-sm" }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { class: "row crm:mb-6 crm:items-start" }
const _hoisted_23 = { class: "control-label col-sm-6" }
const _hoisted_24 = { class: "col-sm" }
const _hoisted_25 = { class: "crm:flex crm:items-center" }
const _hoisted_26 = {
  key: 0,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_27 = { class: "control-label col-sm-6" }
const _hoisted_28 = { class: "col-sm" }

import { watch , ref, inject} from 'vue'
import { usePreventivo } from '../../composable/usePreventivo';
import BaseInputTextArray from "fallco-frontend-framework/src/vue/components/form/BaseInputTextArray.vue";
import FormSocietarioHelper from "../../pages/preventivi/json/societario/helper.json";
import DettaglioPreventivoHelper from "./../../pages/preventivi/json/dettagliopreventivo/helper.json";
import CalcoloEquoCompenso from "./CalcoloEquoCompenso.vue";
import RegimeFiscale from "./RegimeFiscale.vue";
import AliquoteContributiRepertoriali from "./AliquoteContributiRepertoriali.vue";
import {add} from '../../svg/svgs.js'

export default {
  __name: 'FormSocietarioCessioneQuote',
  props: {
  formName: String,
  tipoPreventivo: Object,
  disabilita: Boolean,
  readonly: Boolean
},
  emits: ['changeDatiPreventivo', 'infoCompilazione'],
  setup(__props, { emit: __emit }) {

const {
  categorieValidazione
} = usePreventivo();
const props = __props;
const emits = __emit;
let validazione;
const validazioneEquoCompenso = ref();
const { regimeFiscale } = inject('regimeFiscale')
switch (props.formName) {
  case 'cessioneQuote':
    validazione = categorieValidazione.categoriaSocietario['sottocategoriaCessioneQuote']['cessioneQuote'];
    validazioneEquoCompenso.value = categorieValidazione.categoriaSocietario['sottocategoriaCessioneQuote']['cessioneQuote'];
    break
  case 'recessoDiSocioMedianteRiduzioneDelCapitale':
    validazione = categorieValidazione.categoriaSocietario['sottocategoriaCessioneQuote']['recessoDiSocioMedianteRiduzioneDelCapitale'];
    validazioneEquoCompenso.value = categorieValidazione.categoriaSocietario['sottocategoriaCessioneQuote']['recessoDiSocioMedianteRiduzioneDelCapitale'];
    break
}
const testoInfoCompilazione = ref([]);
testoInfoCompilazione.value =  FormSocietarioHelper.sottocategoriaCessioneQuote[props.formName];
emits('infoCompilazione',  testoInfoCompilazione);
// Aggiungiamo il valore a tipo_parametro che sarà un path alla pagina (mantenendo il nome)
if(validazione){
  validazione.tipo_preventivo.value = 'societario/cessione_quote/' + props.tipoPreventivo.data.url
}
watch(validazione, () => {
  console.log('validazione al click')
  emits('changeDatiPreventivo')
}, { deep: true });
function societaDiPersone (event) {
  if (event.target.checked) {
    validazione.comunicazione_socio_unico.value = ''
  }
}
let indexHelperClosing = {
  calcolo:FormSocietarioHelper.sottocategoriaCessioneQuote[props.formName],
  dettaglio: DettaglioPreventivoHelper.dettaglioPreventivo.descrizioni
}

return (_ctx, _cache) => {
  const _component_the_helper = _resolveComponent("the-helper")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_base_input_checkbox = _resolveComponent("base-input-checkbox")
  const _component_base_select = _resolveComponent("base-select")
  const _directive_fallcohelper = _resolveDirective("fallcohelper")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_the_helper, {
      list: _unref(indexHelperClosing),
      "is-closing": true
    }, null, 8 /* PROPS */, ["list"]),
    (__props.formName === 'cessioneQuote')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_3, [
              _createTextVNode(_toDisplayString(_unref(validazione).prezzo_della_cessione.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.prezzo_della_cessione.ref]
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(BaseInputTextArray, {
                name: "prezzo_della_cessione",
                params: {
            type:_unref(validazione).prezzo_della_cessione.type,
            isvalid: 'true'
          },
                "validate-to": _unref(validazione).prezzo_della_cessione.value,
                "onUpdate:validateTo": _cache[0] || (_cache[0] = $event => ((_unref(validazione).prezzo_della_cessione.value) = $event))
              }, {
                "add-cta": _withCtx(() => [
                  _createElementVNode("span", _hoisted_5, [
                    _cache[9] || (_cache[9] = _createElementVNode("span", null, "Aggiungi valore quota", -1 /* CACHED */)),
                    _createVNode(_component_base_icon, {
                      icon: _unref(add),
                      class: "crm:ml-3",
                      sizing: {width: '15px', height:'15px'}
                    }, null, 8 /* PROPS */, ["icon"])
                  ])
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["params", "validate-to"])
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_7, [
              _createTextVNode(_toDisplayString(_unref(validazione).societa_di_persone.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.societa_di_persone.ref]
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_base_input_checkbox, {
                class: _normalizeClass(props.disabilita ? 'crm:opacity-20  crm:pointer-events-none':''),
                name: "societa_di_persone",
                label: "Sì",
                onChange: _cache[1] || (_cache[1] = $event => (!props.disabilita ? societaDiPersone($event) : '')),
                "validate-to": _unref(validazione).societa_di_persone,
                "onUpdate:validateTo": _cache[2] || (_cache[2] = $event => ((_unref(validazione).societa_di_persone) = $event))
              }, null, 8 /* PROPS */, ["class", "validate-to"])
            ])
          ]),
          (_unref(validazione).societa_di_persone.value !== 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_10, [
                  _createTextVNode(_toDisplayString(_unref(validazione).comunicazione_socio_unico.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.comunicazione_socio_unico.ref]
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_base_input_checkbox, {
                    class: _normalizeClass(props.disabilita ? 'crm:opacity-20  crm:pointer-events-none':''),
                    name: "comunicazione_socio_unico",
                    label: "Sì",
                    "validate-to": _unref(validazione).comunicazione_socio_unico,
                    "onUpdate:validateTo": _cache[3] || (_cache[3] = $event => ((_unref(validazione).comunicazione_socio_unico) = $event))
                  }, null, 8 /* PROPS */, ["class", "validate-to"])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          (_unref(validazione).societa_di_persone.value === 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_13, [
                  _createTextVNode(_toDisplayString(_unref(validazione).ulteriori_modifiche_non_dipendenti_dalla_cessione.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.ulteriori_modifiche_non_dipendenti_dalla_cessione.ref]
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_base_input_checkbox, {
                    class: _normalizeClass(props.disabilita ? 'crm:opacity-20  crm:pointer-events-none':''),
                    name: "ulteriori_modifiche_non_dipendenti_dalla_cessione",
                    label: "Sì",
                    "validate-to": _unref(validazione).ulteriori_modifiche_non_dipendenti_dalla_cessione,
                    "onUpdate:validateTo": _cache[4] || (_cache[4] = $event => ((_unref(validazione).ulteriori_modifiche_non_dipendenti_dalla_cessione) = $event))
                  }, null, 8 /* PROPS */, ["class", "validate-to"])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", _hoisted_15, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_16, [
              _createTextVNode(_toDisplayString(_unref(validazione).forma_del_titolo.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.forma_del_titolo.ref]
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_base_select, {
                name: "forma_del_titolo",
                options: [{name: 'Pubblico', value: 'pubblico'},{name: 'Privato', value: 'privato'}],
                isSelected: _unref(validazione).forma_del_titolo.value !== '',
                state: __props.readonly === true ?'disable':'',
                validateTo: _unref(validazione).forma_del_titolo,
                "onUpdate:validateTo": _cache[5] || (_cache[5] = $event => ((_unref(validazione).forma_del_titolo) = $event))
              }, null, 8 /* PROPS */, ["isSelected", "state", "validateTo"])
            ])
          ]),
          (_unref(regimeFiscale) === 'ordinario')
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_19, [
                  _createTextVNode(_toDisplayString(_unref(validazione).ritenuta_acconto.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.ritenuta_acconto.ref]
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_base_input_checkbox, {
                    class: _normalizeClass(props.disabilita ? 'crm:opacity-20  crm:pointer-events-none':''),
                    name: "ritenuta_acconto",
                    label: "Si, applicabile",
                    "validate-to": _unref(validazione).ritenuta_acconto,
                    "onUpdate:validateTo": _cache[6] || (_cache[6] = $event => ((_unref(validazione).ritenuta_acconto) = $event))
                  }, null, 8 /* PROPS */, ["class", "validate-to"])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          _createVNode(RegimeFiscale, {
            validazione: _unref(validazione),
            helper: _unref(indexHelperClosing),
            readonly: __props.readonly
          }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
          _createVNode(AliquoteContributiRepertoriali, {
            validazione: _unref(validazione),
            helper: _unref(indexHelperClosing),
            readonly: __props.readonly
          }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
          _createVNode(CalcoloEquoCompenso, {
            "input-riferimento-calcolo": "prezzo_della_cessione",
            validazione: validazioneEquoCompenso.value,
            "dynamic-input": true,
            helper: _unref(indexHelperClosing),
            readonly: __props.readonly
          }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"])
        ]))
      : (__props.formName === 'recessoDiSocioMedianteRiduzioneDelCapitale')
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_23, [
                _createTextVNode(_toDisplayString(_unref(validazione).valore_della_riduzione_del_capitale.label), 1 /* TEXT */)
              ])), [
                [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.valore_della_riduzione_del_capitale.ref]
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createVNode(BaseInputTextArray, {
                  name: "prezzo_della_cessione",
                  params: {
            type:_unref(validazione).valore_della_riduzione_del_capitale.type,
            isvalid: 'true'
          },
                  "validate-to": _unref(validazione).valore_della_riduzione_del_capitale.value,
                  "onUpdate:validateTo": _cache[7] || (_cache[7] = $event => ((_unref(validazione).valore_della_riduzione_del_capitale.value) = $event))
                }, {
                  "add-cta": _withCtx(() => [
                    _createElementVNode("span", _hoisted_25, [
                      _cache[10] || (_cache[10] = _createElementVNode("span", null, "Aggiungi valore quota", -1 /* CACHED */)),
                      _createVNode(_component_base_icon, {
                        icon: _unref(add),
                        class: "crm:ml-3",
                        sizing: {width: '15px', height:'15px'}
                      }, null, 8 /* PROPS */, ["icon"])
                    ])
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["params", "validate-to"])
              ])
            ]),
            (_unref(regimeFiscale) === 'ordinario')
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_27, [
                    _createTextVNode(_toDisplayString(_unref(validazione).ritenuta_acconto.label), 1 /* TEXT */)
                  ])), [
                    [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.ritenuta_acconto.ref]
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _createVNode(_component_base_input_checkbox, {
                      class: _normalizeClass(props.disabilita ? 'crm:opacity-20  crm:pointer-events-none':''),
                      name: "ritenuta_acconto",
                      label: "Si, applicabile",
                      "validate-to": _unref(validazione).ritenuta_acconto,
                      "onUpdate:validateTo": _cache[8] || (_cache[8] = $event => ((_unref(validazione).ritenuta_acconto) = $event))
                    }, null, 8 /* PROPS */, ["class", "validate-to"])
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            _createVNode(RegimeFiscale, {
              validazione: _unref(validazione),
              helper: _unref(indexHelperClosing),
              readonly: __props.readonly
            }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
            _createVNode(AliquoteContributiRepertoriali, {
              validazione: _unref(validazione),
              helper: _unref(indexHelperClosing),
              readonly: __props.readonly
            }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
            _createVNode(CalcoloEquoCompenso, {
              "input-riferimento-calcolo": "valore_della_riduzione_del_capitale",
              validazione: validazioneEquoCompenso.value,
              "dynamic-input": true,
              helper: _unref(indexHelperClosing),
              readonly: __props.readonly
            }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"])
          ]))
        : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}
}

}